import React, { useState, useEffect } from "react";
import { ButtonReusableComponent } from "../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";

import { Dialog } from "@material-ui/core";
import { DialogContent } from "@material-ui/core";
import { DialogContentText } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logOutUser } from "../../../store/actions/authAction";
import SocketContext from "../../../function/SocketContext";
import useStateAndRef from "../../../customHooks/useStateAndRef";

function OnlineSession(props) {
  // const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();
  const vendor = JSON.parse(localStorage.getItem("userData"));

  const [open, setOpen, refOpen] = useStateAndRef(false);
  const [offline, setOffline, refOffline] = useStateAndRef(false);

  const handleClickOpen = () => {
    setOpen(true);
    setOffline(true);
  };

  useEffect(() => {
    let interval = setInterval(function () {
      if (!navigator.onLine) {
        handleClickOpen();
      } else if (navigator.onLine && refOffline.current) {
        handleClose();
        if (vendor?.VendorUser?.role === "vendor") {
          window.location.reload();
        }
      }
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  const handleClose = () => {
    setOpen(false);
    setOffline(false);
  };

  const adminLogin = () => {
    dispatch(logOutUser());
    handleClose();
    history.goBack();
    // history.push('/admin-login')
  };

  return (
    <div>
      <Dialog
        open={open}
        // onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        disableBackdropClick
      >
        {/* <DialogTitle id="alert-dialog-title">
          {"Use Google's location service?"}
        </DialogTitle> */}
        <DialogContent className="text-center">
          <DialogContentText id="alert-dialog-description">
            <div className="f16-700">Alert!</div>
            <div className="mt-2 f12-400">
              Due to Network Issue session is on hold. <br />
              Please login again to restart your working.
            </div>
            <div className="mt-3">
              <ButtonReusableComponent
                buttonText="Login"
                buttonType="Submit"
                buttonClass={"activeLogin"}
                onClick={adminLogin}
              />
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}

const OnlineSessionComponent = (props) => (
  <SocketContext.Consumer>
    {(socket) => <OnlineSession {...props} socket={socket} />}
  </SocketContext.Consumer>
);

export default OnlineSessionComponent;
